import { ReactNode } from 'react';

import cn from 'classnames';

import styles from './OfferBlock.module.scss';

const baseClass = 'gdb-offer-block';

type Props = {
  title: string;
  description: string;
  className?: string;
  kicker?: ReactNode;
  tools?: ReactNode;
};

export const OfferBlock = ({ kicker, title, description, tools, className }: Props) => {
  return (
    <div className={cn(styles[`${baseClass}-wrapper`], className)}>
      <div>
        {kicker && <span className={styles[`${baseClass}-kicker`]}>{kicker}</span>}

        <h3 className={styles[`${baseClass}-title`]}>{title}</h3>
        <p className={styles[`${baseClass}-description`]}>{description}</p>
      </div>

      {tools && <div className={styles[`${baseClass}-tools`]}>{tools}</div>}
    </div>
  );
};
